import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

@Component({
  selector: 'app-communication',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './communication.component.html',
  styleUrl: './communication.component.css'
})
export class CommunicationComponent {

  currentTab = 'email';
  tabs = [
    { name: 'email', value: 'email' },
    { name: 'SMS', value: 'sms' },
    { name: 'push notification', value: 'push-notification' },
  ];

  data = {
    "label": ["date", "time", "message", "communicator", "recipient"],
    "data": [
      ["05 Jan, 2025", "12:40 pm", "Enhanced Communication Skills", "Amit Laddha", "6th (A)"],
      ["05 Jan, 2025", "01:00 pm", "Enhanced Communication Skills", "Teacher Name", "All"],
      ["05 Jan, 2025", "03:00 pm", "Enhanced Communication Skills", "Teacher Name", "7th (A)"],
      ["05 Jan, 2025", "12:40 pm", "Enhanced Communication Skills", "Amit Laddha", "6th (A)"],
      ["05 Jan, 2025", "01:00 pm", "Enhanced Communication Skills", "Teacher Name", "All"],
      ["05 Jan, 2025", "03:00 pm", "Enhanced Communication Skills", "Teacher Name", "7th (A)"]
    ]
  }
  

}
